import { Button } from "@mui/material";
import React from "react";

const Contact = () => {

    const hButtonStyle = {color:"white",fontSize:16,fontWeight:"bold"};
    
    function openMailApp(){
        const mailTo = "devshdst0415@icloud.com";
        const subject = "お問い合わせ:ポートフォリオサイト";
        const body = "こちらに問い合わせ内容を入力してください";
        window.location.href = `mailto:${mailTo}?subject=${subject}&body=${body}`
    }

    return(
        <Button style={hButtonStyle} onClick={openMailApp}>
            Contact
        </Button>
    );

}
export default Contact;
